import { forwardRef, type SVGProps } from 'react';

export interface ScaleFromBottomLeftIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const ScaleFromBottomLeftIcon = forwardRef<SVGSVGElement, ScaleFromBottomLeftIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <path
      d="M6 14.5V10H1.5C1.22386 10 1 9.77614 1 9.5C1 9.22386 1.22386 9 1.5 9H6.5C6.77614 9 7 9.22386 7 9.5V14.5C7 14.7761 6.77614 15 6.5 15C6.22386 15 6 14.7761 6 14.5Z"
      fill="currentColor"
    />
    <path
      d="M14.5 1C14.7761 1 15 1.22386 15 1.5V14.5C15 14.7761 14.7761 15 14.5 15H1.5C1.22386 15 1 14.7761 1 14.5V1.5C1 1.36739 1.05272 1.24025 1.14648 1.14648C1.24025 1.05272 1.36739 1 1.5 1H14.5ZM2 14H14V2H2V14Z"
      fill="currentColor"
    />
    <path
      d="M11.6465 3.64645C11.8418 3.45118 12.1583 3.45118 12.3535 3.64645C12.5488 3.84171 12.5488 4.15821 12.3535 4.35348L8.85353 7.85348C8.65827 8.04874 8.34176 8.04874 8.1465 7.85348C7.95125 7.65822 7.95124 7.34171 8.1465 7.14645L11.6465 3.64645Z"
      fill="currentColor"
    />
    <path
      d="M11.5 7.5V4.5H8.5C8.22386 4.5 8 4.27614 8 4C8 3.72386 8.22386 3.5 8.5 3.5H12C12.2761 3.5 12.5 3.72386 12.5 4V7.5C12.5 7.77614 12.2761 8 12 8C11.7239 8 11.5 7.77614 11.5 7.5Z"
      fill="currentColor"
    />
  </svg>
));

ScaleFromBottomLeftIcon.displayName = 'ScaleFromBottomLeftIcon';
